/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Form_Cod_OverrideInputs */

const vi_carrier_form_cod_override = /** @type {(inputs: Carrier_Form_Cod_OverrideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiền hàng thu hộ (đ)`)
};

/**

* @param {Carrier_Form_Cod_OverrideInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_form_cod_override = /** @type {((inputs?: Carrier_Form_Cod_OverrideInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Form_Cod_OverrideInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_form_cod_override(inputs)
});